<template>
  <div>
    <div class="section1 safe-area">
      <pageTitle cn="赛事基础信息" en="Basic Event Info" type="1"></pageTitle>
      <div class="page-flex-lr-center">
        <div class="lf">
          <div class="d5">全球青少年PBL创新素养挑战赛</div>
          <div class="page-flex-lr-center">
            <div class="page-flex-lr-center">
              <div class="label">
                <div class="cn">活动时间</div>
                <div class="en">Event Dates</div>
              </div>
              <div class="value1">2026/10/16-10/18</div>
            </div>
            <div class="page-flex-lr-center">
              <div class="label">
                <div class="cn">活动地点</div>
                <div class="en">Event Location</div>
              </div>
              <div>
                <div class="common-title-d1">中国 深圳</div>
                <div class="common-title-d2">Shenzhen, China</div>
              </div>
            </div>
          </div>
          <div class="page-flex-lr-top mt-20">
            <div class="label">
              <div class="cn">参与对象</div>
              <div class="en">Eligibility</div>
            </div>
            <div class="flex1">
              <div class="common-title-d1">全国各公办、民办、国际以及IB学校中小学在校学生组队参与</div>
              <div class="common-title-d2">Teams of current elementary and secondary school students from public, private, international, and IB schools nationwide</div>
            </div>
          </div>
        </div>
        <div class="rt">
          <img :src="$env.imgUrl + 'pbl2-s1.png'" alt="">
        </div>
      </div>
    </div>
    <div class="section2" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-1.png);'">
      <div class="safe-area">
        <pageTitle cn="四大现场板块" en="Four On-site Zones" type="2"></pageTitle>
        <div class="page-flex-lr-top">
          <div class="item">
            <div class="tit">
              <div class="cn">环球大舞台</div>
              <div class="en">Global Stage</div>
            </div>
            <img :src="$env.imgUrl + 'pbl2-s3-1.png?v=0731'" alt="">
          </div>
          <div class="item">
            <div class="tit">
              <div class="cn">环球博览会</div>
              <div class="en">Global Expo</div>
            </div>
            <img :src="$env.imgUrl + 'pbl2-s3-2.png?v=0720'" alt="">
          </div>
          <div class="item">
            <div class="tit">
              <div class="cn">环球嘉年华</div>
              <div class="en">Global Carnival</div>
            </div>
            <img :src="$env.imgUrl + 'pbl2-s3-3.png?v=0720'" alt="">
          </div>
          <div class="item">
            <div class="tit">
              <div class="cn">环球之夜晚宴</div>
              <div class="en">Global Gala Dinner</div>
            </div>
            <img :src="$env.imgUrl + 'pbl2-s3-4.png?v=0720'" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="section3">
      <div class="safe-area">
        <pageTitle cn="四项成果展示" en="Exhibition of Four Works" type="1"></pageTitle>
        <div class="common-title-d1 mt-20">四项成果独立计分，最后核算总分决出年度优胜队伍。</div>
        <div class="common-title-d2 mt-12">The four achievements are scored independently, and the final total score determines the annual winning team.</div>
        <div class="imgs">
          <img :src="$env.imgUrl + 'pbl2-s2-1.png?v=073117'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s2-2.png?v=0731'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s2-3.png?v=0731'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s2-4.png?v=0731'" alt="">
        </div>
      </div>
    </div>
    <div class="section4" :style="'background-image: url(' + $env.imgUrl + 'pbl-bg-2.png);'">
      <div class="safe-area">
        <pageTitle cn="具体时间节点" en="Specific timeline" type="2"></pageTitle>
        <div class="common-title-d3 mt-20">为保障赛事有序开展、各校高效备赛参赛，明确工作要求及关键时间节点如下，所有事项逾期不予受理：</div>
        <div class="common-title-d4 mt-12">To ensure the orderly conduct of the event and efficient preparation and participation by all schools, the work requirements and key time nodes are clarified as follows. All matters overdue will not be accepted:</div>
        <div class="time-line">
          <div class="time-item" v-for="(item, index) in timeLine" :key="index">
            <div class="cn">{{ item.cn }}</div>
            <div class="en">{{ item.en }}</div>
            <div class="dot"></div>
            <div class="date">{{ item.date }}</div>
          </div>
          <div class="line"></div>
        </div>
        <div class="imgs">
          <img :src="$env.imgUrl + 'pbl2-s4-1.png'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s4-2.png'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s4-3.png'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s4-4.png'" alt="">
          <img :src="$env.imgUrl + 'pbl2-s4-5.png'" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      timeLine: [
        {
          cn: '注册备案',
          en: 'Registration and filing',
          date: '即日起—2026年07月31日'
        },
        {
          cn: '正式报名与缴费',
          en: 'Official registration and payment',
          date: '2026年07月01日 - 08月31日'
        },
        {
          cn: '报名参与教师培训',
          en: 'Sign up for teacher training',
          date: '2026年08月'
        },
        {
          cn: '参赛作品打磨与上传',
          en: 'Polishing and uploading of contest entries',
          date: '2026年09月01日 - 10月15日'
        },
        {
          cn: '现场参赛',
          en: 'On-site competition',
          date: '2026年10月16日 - 10月18日'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.d5{
  color: #000;
  font-family: systh;
  font-size: 22px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
.section1{
  padding: 30px 0 40px;
  .lf{
    width: 40%;
  }
  .rt{
    flex: 1;
    padding-left: 20px;
    img{
      width: 100%;
      height: auto;
    }
  }
}
.label{
  background-color: #C9273A;
  color: #fff;
  padding: 4px;
  border-radius: 8px;
  margin-right: 10px;
  text-align: center;
  width: 80px;
  .cn{
    font-family: alih;
    font-size: 14px;
  }
  .en{
    font-size: 10px;
  }
}
.flex1{
  flex: 1;
}
.value1{
  font-size: 14px;
  font-family: alim;
  margin-right: 10px;
}
.section2{
  padding: 80px 0;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .item{
    width: 25%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    img{
      width: 100%;
      height: auto;
    }
    .tit{
      text-align: center;
      margin-bottom: 12px;
      .cn{
        font-family: systh;
        font-size: 16px;
        color: #fff;
      }
      .en{
        font-family: systh;
        font-size: 10px;
        color: #FD8E86;
      }
    }
  }
}
.section3 {
  .imgs{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    img{
      width: 24%;
      height: auto;
    }
  }
}
.section4{
  padding: 120px 0 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .imgs{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    img{
      width: 19%;
      height: auto;
    }
  }
}
.time-line{
  display: flex;
  position: relative;
  margin: 40px 0 10px;
  .time-item{
    width: 20%;
    text-align: center;
    .cn{
      font-size: 18px;
      font-family: systh;
      color: #fff;
    }
    .en{
      font-size: 10px;
      font-family: systm;
      color: #FD8E86;
    }
    .date{
      font-size: 12px;
      font-family: systm;
      color: #fff;
    }
    .dot{
      width: 10px;
      height: 10px;
      background-color: #fff;
      border-radius: 10px;
      margin: 20px auto;
    }
  }
  .line{
    position: absolute;
    left: 10%;
    right: 10%;
    bottom: 42px;
    height: 2px;
    background-color: #fff;
  }
}
</style>
